var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrinkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "40.000000pt",
    height: "40.000000pt",
    viewBox: "0 0 40.000000 40.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,40.000000) scale(0.100000,-0.100000)",
    fill: "#f5f5f5",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56 379 c-19 -15 -26 -30 -26 -54 0 -36 13 -50 74 -81 23 -11 47 -33 54 -47 7 -15 24 -35 38 -43 21 -14 24 -24 24 -75 0 -56 -1 -59 -25 -59 -14 0 -25 -4 -25 -10 0 -6 28 -10 65 -10 64 0 91 16 38 22 -27 3 -28 6 -31 61 -3 53 -1 58 23 67 14 5 31 22 38 37 6 16 24 39 40 51 21 19 27 33 27 63 l0 39 -100 0 c-80 0 -100 3 -100 14 0 19 -39 46 -66 46 -12 0 -33 -9 -48 -21z m75 -19 l24 -19 -32 -1 c-30 0 -33 -3 -33 -30 0 -32 -9 -37 -28 -18 -19 19 -14 55 10 72 28 20 31 20 59 -4z m219 -60 c0 -6 -47 -10 -120 -10 -73 0 -120 4 -120 10 0 6 47 10 120 10 73 0 120 -4 120 -10z m-24 -45 c-10 -8 -22 -16 -25 -17 -3 -2 -13 -16 -21 -33 -26 -51 -100 -44 -100 10 0 16 -8 25 -25 29 -57 14 -20 26 83 26 95 -1 105 -2 88 -15z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrinkIcon);
export default __webpack_public_path__ + "static/media/drinkIcon.591cf94efdd5f034ed4520c624bbbeee.svg";
export { ForwardRef as ReactComponent };